<template>
	<div class="modal-card" style="width: auto; min-width: 680px">
		<header class="modal-card-head">
			<p class="modal-card-title">{{ title }}</p>
		</header>
		<section class="modal-card-body">
			<div v-html="message" v-if="isString"></div>
			<component :is="message" v-else></component>
		</section>
		<footer class="modal-card-foot">
			<o-button variant="light" @click="Cancel">{{ btnText }}</o-button>
		</footer>
	</div>
</template>
<script>
	import { ref, computed, inject, onMounted } from "vue";
	import store from "@/store";
	export default {
		props: {
			title: {
				type: String,
				default: ""
			},
			message: {
				type: [String, Object],
				default: () => {
					return undefined;
				}
			},
			btnText: {
				type: String,
				default: "Close"
			}
		},
		emits: ["close"],
		setup(props, context) {
			const isString = computed(() => {
				return typeof props.message === "string";
			});

			const Cancel = () => {
				context.emit("close");
			};

			return {
				isString,
				Cancel
			};
		}
	};
</script>
